import bgPc from '@/assets/images/bg-pc.png';
import logo from '@/assets/images/logo.svg';
import application from '@/stores/application';
import { observer, useObserver } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ConnectWalletButton from '../ConnectWalletButton';
interface Props {
    showConnectButton?: boolean;
    connected?: boolean;
    onClickConnect?(): void;
    onClickDisconnect?(): void;
    address?: string;
    showLanguage?: boolean;
    notSupportedChain?: boolean;
}

function Header(props: Props) {
    const { t } = useTranslation();
    const { showLanguage } = props;

    const history = useHistory();

    return useObserver(() => (
        <div
            style={{ backgroundImage: `url(${bgPc})` }}
            className="bg-[url(${require('@/assets/images/bg-pc.png')})] fixed left-0 top-0 z-[88] flex h-[90px] w-full items-center justify-between bg-cover px-[30px] max-md:h-[70px] max-md:px-[20px]"
        >
            <img
                className="h-[35px] cursor-pointer max-md:h-[20px]"
                src={logo}
                alt="LazAI logo"
                onClick={() => {
                    history.push('/');
                }}
            />
            {!application.comingSoon && <ConnectWalletButton />}
        </div>
    ));
}

export default observer(Header);
